import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { OrderDetailsComponentService } from '../../order-details.component-service';

@Component({
  selector: 'sd-order-delivery-filter',
  styleUrls: ['order-delivery-filter.component.scss'],
  templateUrl: 'order-delivery-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderDeliveryFilterComponent implements OnInit {
  isDelivery = new FormControl();

  showDeliverySwitch$ = new BehaviorSubject<boolean>(false);

  constructor(
    private orderDetailsComponentService: OrderDetailsComponentService,
    private cdr: ChangeDetectorRef,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.orderDetailsComponentService
      .getDeliveryFilter()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isDelivery) => {
        this.isDelivery.setValue(isDelivery, { emitEvent: false });
        this.cdr.markForCheck();
      });

    this.isDelivery.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isDelivery) => {
      this.orderDetailsComponentService.setDeliveryFilter(isDelivery);
    });
  }
}
